import React, { Component } from "react";
import "./NavBar.scss";
import { mobile } from "../Services/Agent";
import { __AreasMenuLabel__ } from "../Helpers/ArrayGrouping";
import { GA_Push, GA_Event } from "../Services/GoogleAnalytics";

export default class NavBar extends Component {
    constructor(props) {
        super();
        this.clickMenu = this.clickMenu.bind(this);
        this.renderAreas = this.renderAreas.bind(this);
        this.setLocation = this.setLocation.bind(this);
        this.setIni8Pin = this.setIni8Pin.bind(this);
        this.fixMenuOnScroll = this.fixMenuOnScroll.bind(this);
        this.state = {
            isActive: false,
            isBusy: false,
            currentPin: 0
        }
    }
    clickMenu() {
        this.setState({
            isActive: !this.state.isActive
        }, () => {
            if (this.state.isActive == true) {
                this.setState({
                    isBusy: true
                })
                window.setTimeout(() => {
                    this.setState({
                        isBusy: false
                    })
                }, 700);
            } else {
                this.setState({
                    isBusy: false
                })
            }
        })
    }
    componentDidMount() {
        this.setIni8Pin(this.props);
        window.setTimeout(this.fixMenuOnScroll, 1000);
    }
    componentWillReceiveProps(nP) {
        this.setIni8Pin(nP);
    }
    fixMenuOnScroll() {
        var rect = this.navBar.getBoundingClientRect();
        let cards = window.document.querySelector(".section-cards");
        cards.addEventListener("scroll", (event) => {
            if (this.navBar == null) return;
            let rectAfter = this.navBar.getBoundingClientRect();

            if (cards.scrollTop <= 0.05 * cards.clientHeight) {
                this.navBar.style.position = "fixed";
                this.navBar.style.top = "";
                this.navBar.style.right = "";
            } else {
                if (rect.top != rectAfter) {
                    this.navBar.style.position = "absolute";
                    this.navBar.style.top = `${-rect.top}px`;
                    this.navBar.style.right = `${-this.navBar.parentElement.scrollLeft}px`;
                }
            }
        })
    }
    setIni8Pin(props) {
        if (!props.area) return;
        this.setState({
            currentPin: props.area
        })
    }
    setLocation(loc) {
        if (this.state.isBusy) return;
        this.setState({
            isBusy: true
        }, () => {
            this.setIni8Pin({ area: loc });
            this.props.setLocation(loc);
            window.setTimeout(() => {
                this.setState({
                    isBusy: false
                })
            }, 1000);
        })
    }
    renderAreas() {
        let list = [];
        let labels = __AreasMenuLabel__();
        if (this.state.currentPin > 0 && mobile()) {
            let firstItem = __AreasMenuLabel__().filter(a => a.Order == this.state.currentPin);
            labels.splice(this.state.currentPin - 1, 1);
            labels.unshift(firstItem[0]);
        }
        labels.map((item, index) => {
            list.push(
                <div
                    className={`option ${this.state.currentPin == item.Order ? " active" : ""}`}
                    key={index}
                    onClick={() => {
                        // GA_Push("Continent_Clicked", item.Mainland + " - NavBar");
                        GA_Event("Navigation_Events", "Last Call - Navigation", item.Land, "Top Bar")
                        this.setLocation(item.Order);
                    }}
                >
                    {item.Mainland}
                </div>
            );
        })
        return list;
    }
    render() {
        return (
            <menu id="navbar" ref={navBar => this.navBar = navBar}>
                <div className="nav-container">
                    <div className={`options${this.state.isActive ? " active" : ""}`} onClick={this.clickMenu}>
                        <div className="arrow"></div>
                        <div className="options-list">
                            {this.renderAreas()}
                        </div>
                    </div>
                    <div className="backtomap" onClick={() => {
                        this.props.resetState();
                        GA_Event("Navigation_Events", "Last Call - Navigation", "Back To Map")
                        }}>
                        <div className="icon"></div>
                        <div className="label">חזרה למפה</div>
                    </div>
                </div>
            </menu>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/NavBar/NaBar.jsx